import {withTranslation} from "react-i18next";
import React from "react";


function AccountCenter(props) {
    const {t, user, userProfile} =props;

    return <div className={"cardStudent"}>
        {/* ToDo : Revisar carga de datos */}
        <div className={"itemCard itemCardHeader"}>{t("informes.card.title")}</div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("account.emailcentro")}:</div>
            <div className={"itemCardRight"}>{userProfile.email}</div>
        </div>

        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("account.telef")}:</div>
            <div className={"itemCardRight"}>{userProfile.phone}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("account.director")}:</div>
            <div className={"itemCardRight"}>{userProfile.directorName} {userProfile.directorSurname}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("account.email")}:</div>
            <div className={"itemCardRight"}>{userProfile.directorEmail}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("account.direccion")}:</div>
            <div className={"itemCardRight"}>{userProfile.address}</div>
        </div>
        <div className={"itemCard"}>
            <div className={"itemCardLeft"}>{t("account.codigo")}:</div>
            <div className={"itemCardRight"}>{userProfile.code}</div>
        </div>

    </div>

}


export default withTranslation()(AccountCenter);
